import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { fromCountryToFlag, getAllCountries } from '~/src/dash/utils/countries';
import { isPublisherSamsung } from '~/src/dash/utils/publishers';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';
import { ETargetingDeviceIDTypes } from '~/src/dash/api/console-api';

export const SlotOptions: ISelectOption[] = [
  // id 0 means all
  { id: 1, label: '1' },
  { id: 2, label: '2' },
  { id: 3, label: '3' },
  { id: 4, label: '4' },
  { id: 5, label: '5' },
  { id: 6, label: '6' },
  { id: 7, label: '7' },
  { id: 8, label: '8' },
  { id: 9, label: '9' },
  { id: 10, label: '10' },
];

export enum EPositionTargeting {
  ALL = 0,
  PREROLL,
  MIDROLL,
  POSTROLL,
}

export const PositionTargetingOptions: ISelectOption[] = [
  { id: EPositionTargeting.ALL, label: 'All' },
  { id: EPositionTargeting.PREROLL, label: 'Preroll' },
  { id: EPositionTargeting.MIDROLL, label: 'Midroll' },
  { id: EPositionTargeting.POSTROLL, label: 'Postroll' },
];

export enum EPodSequenceTargeting {
  ANY = 0,
  FIRST,
  LAST,
  FIRST_AND_LAST,
}

export const PodSequenceTargetingOptions: ISelectOption[] = [
  { id: EPodSequenceTargeting.ANY, label: 'Any Pod' },
  { id: EPodSequenceTargeting.FIRST, label: 'First Pod' },
  { id: EPodSequenceTargeting.LAST, label: 'Last Pod' },
  { id: EPodSequenceTargeting.FIRST_AND_LAST, label: 'First & Last Pods' },
];

export enum ETargetedAdBreak {
  ALL = 0,
  FIRST,
  LAST,
}

export const TargetedAdBreakOptions: ISelectOption[] = [
  { id: ETargetedAdBreak.ALL, label: 'All' },
  { id: ETargetedAdBreak.FIRST, label: 'First' },
  { id: ETargetedAdBreak.LAST, label: 'Last' },
];

export enum EAllowStatus {
  UNKNOWN = 0,
  DENY,
  ALLOW,
}

export enum ELogicalOperator {
  OR = 0,
  AND,
}

export enum ETargetingCOPPA {
  COPPA_ALL = 0,
  COPPA_0,
  COPPA_1,
}

export const TargetingCOPPAOptions: ISelectOption[] = [
  { id: ETargetingCOPPA.COPPA_ALL, label: 'All' },
  { id: ETargetingCOPPA.COPPA_0, label: '0' },
  { id: ETargetingCOPPA.COPPA_1, label: '1' },
];

export enum ETargetBool {
  ALL = 0,
  FALSE,
  TRUE,
}

export const TargetBoolOptions: ISelectOption[] = [
  { id: ETargetBool.ALL, label: 'All' },
  { id: ETargetBool.FALSE, label: 'False' },
  { id: ETargetBool.TRUE, label: 'True' },
];

export enum ETargetingCCPA {
  ALL = 0,
  OPT_OUT,
  NON_OPT_OUT,
}

export const TargetingCCPAOptions: ISelectOption[] = [
  { id: ETargetingCCPA.ALL, label: 'All' },
  { id: ETargetingCCPA.OPT_OUT, label: 'Opt Out' },
  { id: ETargetingCCPA.NON_OPT_OUT, label: 'Non Opt Out' },
];

export enum ETargetingGDPR {
  ALL = 0,
  GDPR0,
  GDPR1,
}

export const TargetingGDPROptions: ISelectOption[] = [
  { id: ETargetingGDPR.ALL, label: 'All', tKey: 'All' },
  { id: ETargetingGDPR.GDPR0, label: '0' },
  { id: ETargetingGDPR.GDPR1, label: '1' },
];

export enum ETargetingGDPRConsent {
  ALL = 0,
  TRUE,
  FALSE,
}

export const TargetingGDPRConsentOptions: ISelectOption[] = [
  { id: ETargetingGDPRConsent.ALL, label: 'All', tKey: 'All' },
  { id: ETargetingGDPRConsent.TRUE, label: '0' },
  { id: ETargetingGDPRConsent.FALSE, label: '1' },
];

export const TargetingDeviceIDTypeOptions: ISelectOption[] = [
  { id: ETargetingDeviceIDTypes.ALL, label: 'All', tKey: 'All' },
  { id: ETargetingDeviceIDTypes.ORIGINAL, label: 'Original DIDs', tKey: 'OriginalDIDs' },
  { id: ETargetingDeviceIDTypes.SYNTHETIC, label: 'Synthetic DIDs', tKey: 'SyntheticDIDs' },
];

export enum ETargetingLiveStream {
  ALL = 0,
  LIVE,
  VOD,
  DVR,
}

export const TargetingLiveStreamOptions: ISelectOption[] = [
  { id: ETargetingLiveStream.LIVE, label: 'Live' },
  { id: ETargetingLiveStream.VOD, label: 'VOD' },
  { id: ETargetingLiveStream.DVR, label: 'DVR' },
];

// TODO: ARRAYS LIKE THIS SHOULD BE MOVED TO THE BACKEND
export const DeviceOptions: ISelectOption[] = [
  // id 0 means all
  { id: 1, label: 'Android Mobile' },
  { id: 2, label: 'Android Tablet' },
  { id: 3, label: 'Android TV' },
  { id: 4, label: 'Fire TV' },
  { id: 5, label: 'iOS Mobile' },
  { id: 6, label: 'iOS Tablet' },
  { id: 7, label: 'Apple TV' },
  { id: 8, label: 'Playstation' },
  { id: 9, label: 'Roku' },
  { id: 10, label: 'Xbox' },
  { id: 11, label: 'Samsung TV' },
  { id: 12, label: 'Chromecast' },
  { id: 13, label: 'Other' },
  { id: 14, label: 'Vizio' },
  { id: 15, label: 'LG' },
  { id: 16, label: 'Dish' },
  { id: 17, label: 'Hisense' },
  { id: 18, label: 'Nvidia' },
  { id: 19, label: 'Phillips' },
  { id: 20, label: 'Huawei' },
  { id: 21, label: 'Tcl' },
  { id: 22, label: 'Tivo' },
  { id: 23, label: 'Bravia' },
  { id: 24, label: 'Comcast' },
  { id: 25, label: 'Sharp' },
  { id: 26, label: 'Panasonic' },
  { id: 27, label: 'Sanyo' },
  { id: 28, label: 'Desktop' },
  { id: 29, label: 'AirTV' },
  { id: 30, label: 'Xiaomi' },
  { id: 31, label: 'AT&T' },
  { id: 32, label: 'Samsung Family Hub' },
];

export const DeviceORTBTypeOptions: ISelectOption[] = [
  { id: 0, label: 'Unknown Device Type' },
  { id: 2, label: 'Desktop' },
  { id: 3, label: 'Connected TV' },
  { id: 4, label: 'Mobile' },
  { id: 5, label: 'Tablet' },
  { id: 6, label: 'Connected Device' },
  { id: 7, label: 'Set-Top Box' },
];

export const SamsungDeviceSubTypeOptions: ISelectOption[] = [
  // id 0 means all
  { id: 1, label: 'Samsung Tizen 2.3' },
  { id: 2, label: 'Samsung Tizen 2.4' },
  { id: 3, label: 'Samsung Tizen 3.0' },
  { id: 4, label: 'Samsung Tizen 4.0' },
  { id: 5, label: 'Samsung Tizen 5.0' },
  { id: 6, label: 'Samsung Tizen 5.5' },
  { id: 7, label: 'Samsung Tizen 6.0' },
  { id: 8, label: 'Samsung Tizen 6.5' },
  { id: 9, label: 'Samsung Tizen 7.0' },
  { id: 10, label: 'Samsung Tizen 8.0' },
  { id: 11, label: 'Samsung Tizen 9.0' },
];

export const ExtendedIDTargetingTypeOptions: ISelectOption[] = [
  { id: 1, label: 'Disabled', tKey: 'Disabled' },
  { id: 2, label: 'Target If Present', tKey: 'TargetIfPresent' },
  { id: 3, label: 'Target If Missing', tKey: 'TargetIfMissing' },
];

export const SamsungDeviceModelOptions: ISelectOption[] = [
  // id 0 means all
  { id: 1, label: 'TV Plus AI Home' },
  { id: 2, label: 'Other' },
];

export const generateCountryOptions = (): ISelectOption[] => {
  const options: ISelectOption[] = [];
  getAllCountries().forEach((country) => {
    options.push({
      id: country.key,
      label: `${fromCountryToFlag(country)} ${country.text}`,
    });
  });
  return options;
};

// IF YOU ADD TO THIS, MAKE SURE TO ADJUST THE VALUE CONVERSIONS IN TARGETING CONFIG
export const generateDeviceSubTypeOptionsList = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  const options = [] as ISelectOption[];
  if (isPublisherSamsung(session.publisher.ID)) {
    return new Promise((resolve) => resolve(SamsungDeviceSubTypeOptions));
  } else if (hasRoleSuperUser(user.user)) {
    SamsungDeviceSubTypeOptions.forEach((option) => {
      options.push({
        ...option,
        label: option.label + ' *',
      });
    });
  }
  return new Promise((resolve) => resolve(options));
};

export const generateDeviceModelsOptionsList = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  const options = [] as ISelectOption[];
  if (isPublisherSamsung(session.publisher.ID)) {
    return new Promise((resolve) => resolve(SamsungDeviceModelOptions));
  } else if (hasRoleSuperUser(user.user)) {
    SamsungDeviceModelOptions.forEach((option) => {
      options.push({
        ...option,
        label: option.label + ' *',
      });
    });
  }
  return new Promise((resolve) => resolve(options));
};
